import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_hjkebjzfnc: FaireCollectionEntity = {
  token: "pbc_hjkebjzfnc",
  type: "collection",
  name: "GAME DAY READY",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e05a6c7c1069e35a71e58c69ab7d4d9c5ea0e486c271e9f0e03e943d900c71a4.jpeg",
  itemCount: 30,
  brandToken: "b_q8gu9by5sv",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:48:54.568Z",
    importedBy: "entity-db-import-collections",
  },
};
